export default "__VITE_ASSET__d9ac9605__"